import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { Service } from "@/types/dashboard";
import { ServicePricing } from '../pricing/ServicePricing';
import { ServiceDetails } from '../service-details/ServiceDetails';
import { useTranslation } from 'react-i18next';

interface ServiceCardContentProps {
  service: Service;
  currency?: string | null;
  businessName?: string;
  onViewClick: () => void;
  onRequestClick: () => void;
  hasImage?: boolean;
}

export const ServiceCardContent = ({
  service,
  currency,
  businessName,
  onViewClick,
  onRequestClick,
  hasImage = true
}: ServiceCardContentProps) => {
  const { t } = useTranslation();
  
  return (
    <div className={`p-4 flex-1 flex flex-col ${!hasImage ? 'compact-content' : ''}`}>
      <div className="flex justify-between items-start mb-2">
        <ServiceDetails 
          service={service}
          businessName={businessName}
          variant="compact"
        />
        
        <ServicePricing
          price={service.price}
          discountedPrice={service.discounted_price}
          travelFee={service.travel_fee}
          currency={currency}
          serviceMode={service.service_mode}
          variant="compact"
        />
      </div>
      
      {service.description && (
        <p className="text-sm text-gray-600 mb-3 line-clamp-3 break-words">
          {service.description}
        </p>
      )}
      
      <div className="flex justify-between gap-2 mt-auto">
        <Button 
          variant="outline" 
          size="sm" 
          className="flex-1 flex items-center justify-center gap-1 text-xs sm:text-sm"
          onClick={onViewClick}
        >
          <Eye className="h-3 w-3 sm:h-4 sm:w-4" />
          {t('servicePage.view')}
        </Button>
        <Button 
          size="sm" 
          className="flex-1 bg-gradient-to-r from-gebeya-pink to-gebeya-orange hover:opacity-90 text-white text-xs sm:text-sm"
          onClick={onRequestClick}
        >
          {t('servicePage.request')}
        </Button>
      </div>
    </div>
  );
};
